import API from "../api";

function walletBase(managerMode = false) {
  return managerMode ? "/manager/wallet" : "/admin/wallet";
}

/**
 * GET wallet balance + full transaction history for a student.
 */
export async function fetchWallet(studentId, { managerMode = false } = {}) {
  const res = await API.get(`${walletBase(managerMode)}/${studentId}`);
  return res?.data?.data || res?.data;
}

export async function topupWallet(payload, { managerMode = false } = {}) {
  const res = await API.post(`${walletBase(managerMode)}/topup`, payload);
  return res?.data?.data || res?.data;
}

export async function refundWallet(payload) {
  const res = await API.post("/admin/wallet/refund", payload);
  return res?.data?.data || res?.data;
}

export async function modifyWalletTransaction(payload) {
  const res = await API.patch("/admin/wallet/transaction/modify", payload);
  return res?.data?.data || res?.data;
}

export async function revertWalletTransaction(payload) {
  const res = await API.delete("/admin/wallet/transaction/revert", {
    data: payload,
  });
  return res?.data?.data || res?.data;
}
